import { Box, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const RouteTypeLegend = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Divider sx={{ my: 1 }} />
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        {t("logisticsRouteTypes")}
      </Typography>
      <Stack spacing={0.5}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              width: 24,
              height: 0,
              borderTop: "3px solid",
              borderColor: "text.secondary",
            }}
          />
          <Typography variant="body2">{t("logisticsRailRoute")}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              width: 24,
              height: 0,
              borderTop: "3px dashed",
              borderColor: "text.secondary",
            }}
          />
          <Typography variant="body2">
            {t("logisticsTruckEstimated")}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
